<template>
    <div :class="$style.body" class="backgray fs16 fw">
        <p class="center">
            <img :src="waurl" style="width: 100%;" alt="" @click="goWhatsapp" class="cp biggerpic">
        </p>
        <p class="center fs18" style="margin: 30px 0px 10px 0px;">{{ $t('pr1') }}</p>
        <p class="dflex fw300">
            <span class="right" :class="$style.right">{{ $t('pr2') }}</span>
            <span class="f1">11:00 am - 5:30 pm</span>
        </p>
        <p class="dflex fw300">
            <span class="right" :class="$style.right">{{ $t('pr3') }}</span>
            <span class="f1">10:30 am - 2:00 pm</span>
        </p>
        <p class="center fs18"  style="margin: 30px 0px 10px 0px;">{{ $t('pr4') }}</p>
        <div  class="fw300 mb30">
            <p>Hi, this is Mr.Lee, </p>
            <p>{{ $t('sm1') }}</p>
            <p>{{ $t('sm2') }}</p>
            <p>{{ $t('sm3') }}</p>
            <p>{{ $t('sm4') }}</p>
            <p>{{ $t('sm5') }}</p>
            <p>{{ $t('sm6') }}</p>
        </div>
        <p>{{ $t('sm7') }}</p>
    </div>
</template>
<script>
import waen from '../assets/whatsapp_en.jpg';
import wazh from '../assets/wahtsapp_cn.jpg';

export default {
    data() {
        return {
            waurl: this.$i18n.locale === 'en' ? waen : wazh,
        }
    }
}
</script>
<style module>
.right {
    padding-right:30px;
    width:160px;
}
.body {
    width: 500px;
    padding: 75px 60px;
}
@media screen and (max-width: 770px) {
    .right {
        width:39%;
        padding-right: 10px;
    }
    .body {
        width: 80%;
        padding: 40px;
        margin-bottom: 30px;
    }
}
</style>
